import React from 'react'

import './styles.scss'

const BillItem = ({ name, prevPrice, currPrice, isSelected, onItemClick }) => {
	return (
		<div className="bill-item" onClick={onItemClick}>
			<div
				className={`bill-item__checkbox ${
					isSelected ? 'bill-item__checkbox--active' : ''
				}`}
			>
				<img
					src="/images/bag/tick.png"
					alt="Check mark."
					className="bill-item__checkbox__tick"
				/>
			</div>
			<div className="bill-item__description">
				<p className="bill-item__description__name">{name}</p>
				<div className="bill-item__description__price">
					<p className="bill-item__description__price__prev">USD {prevPrice}</p>
					<p className="bill-item__description__price__curr">USD {currPrice}</p>
				</div>
			</div>
		</div>
	)
}

export { BillItem }
